// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mobile-menu[data-v-07757778]{position:fixed;display:flex;justify-content:space-around;gap:28px;width:100%;bottom:0;left:0;right:0;z-index:25;height:83px;background:var(--black-gradient);box-shadow:var(--black-shadow);box-sizing:border-box;padding:16px 16px 23px 16px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
